/*jshint esversion: 8 */
// import jwt_decode from 'jwt-decode';
// import backendService from './backendService';
import '../css/login.css';
import 'babel-polyfill';
import { autoRedirect } from './authService.js';
import zlFetch from "zl-fetch";
// Se dok for zlFetch her:  https://github.com/zellwk/zl-fetch
//import { swalAlert } from './commonService';
// const urlLogout = process.env.LOGOUT_URL;
//const urlLoginRefresh = process.env.LOGINREFRESH_URL;
const urlLogin = process.env.LOGIN_URL;

window.basicLogin = basicLogin;

export async function basicLogin() {
  document.body.style.cursor = 'progress';
  const email = document.getElementById("email");
  const password = document.getElementById("password");
  let response;
  if (email.checkValidity() && password.checkValidity()) {
    try {
      response = await zlFetch.post(urlLogin, {
        credentials: 'include',
        // headers: { "Access-Control-Allow-Origin": "http://localhost:1234/"},
        body: {
          "name": email.value,
          "password": password.value
        }
      });
    } catch (err) {
      document.body.style.cursor = 'auto';
      if (err.status === 401) {
        addLoginMessages('Logginn feilet, sjekk brukernavn og passord');
      }
      addLoginMessages('Logginn feilet');
      return;
    }
    const {
      token
    } = response.body;
    localStorage.setItem('token', token);
    localStorage.setItem('notFirsttime', true);
    document.body.style.cursor = 'auto';
    autoRedirect();
  }
};


function addLoginMessages(message) {
  if ($('#message').length > 0) {
    $('#message').text(message);
  }
}
